import { InjectionToken } from '@angular/core';
import { MarketConfig } from './market-config';
import { MARKET_DE } from './market.de';

/**
 * The market (country setup) of this app start – set once by main.ts, BEFORE Angular boots (D23).
 * The default MARKET_DE is for the unit tests, which bootstrap without main.ts.
 */
let resolvedMarket: MarketConfig = MARKET_DE;

/** Called exactly once, by main.ts. */
export function setAppMarket(market: MarketConfig): void {
  resolvedMarket = market;
}

/**
 * The market for code that runs OUTSIDE dependency injection (module-level configuration like the
 * cookie banner, plain classes like ServicetaskFactory). Components and services inject MARKET instead.
 */
export function appMarket(): MarketConfig {
  return resolvedMarket;
}

/**
 * Inject this token wherever the code needs to know the current market:
 *   private readonly market = inject(MARKET);
 *
 * The factory makes the token available everywhere – also in the existing unit tests, which don't provide it.
 * A test can still choose another market: { provide: MARKET, useValue: MARKET_IE }.
 */
export const MARKET = new InjectionToken<MarketConfig>('MARKET', {
  providedIn: 'root',
  factory: () => appMarket(),
});
